/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Resultinfo1Inputs */

const de__field_resultinfo1 = /** @type {(inputs: _Field_Resultinfo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzter CHANCENkurve Test`)
};

/**

* @param {_Field_Resultinfo1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_resultinfo1 = /** @type {((inputs?: _Field_Resultinfo1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Resultinfo1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_resultinfo1(inputs)
});
export { _field_resultinfo1 as "_field_resultInfo" }